import { CoordsObjectType, MarkersData } from "@/common/types";
import { geocodeLatLng } from "@/common/utils";
import { Map, useMap } from "@vis.gl/react-google-maps";
import { ReactNode, useEffect } from "react";
import PickedMarkers from "./PickedMarker";
import NearByMarkers from "./NearByMarkers";
const options = {
  // style: { width: "100vw", height: "100vw" },
  zoomControl: false,
  streetViewControl: false,
  mapTypeControl: false,
  fullscreenControl: false,
  disableDefaultUI: true,
};
const MAP_ID_KEY = import.meta.env.VITE_MAP_ID_KEY;

interface BaseMapProps {
  center: { lat: number; lng: number };
  markers?: MarkersData[];
  className?: string;
  style: React.CSSProperties;
  pickAddress?: (
    data: {
      position: CoordsObjectType;
      full_address: string;
    },
    from: number
  ) => void;
  isActions?: boolean;
  children?: ReactNode;
  details?: (marker: any) => ReactNode;
  nearByMarkers?: { near50: MarkersData[]; near300: MarkersData[] };
}

export default function BaseMap({
  pickAddress,
  center,
  markers,
  nearByMarkers,
  isActions,
  style,
}: BaseMapProps) {
  const map = useMap();

  useEffect(() => {
    if (map && center) {
      map.panTo(center);
    }
    if (markers?.length) {
      map?.panTo(markers[0].position);
    }
  }, [center, markers]);

  const onMapClick = (event: any) => {
    return;
    if (isActions) return;
    const newPos = {
      lat: event.detail.latLng.lat,
      lng: event.detail.latLng.lng,
    };
    geocodeLatLng(newPos, (_, address) => {
      if (pickAddress && event.detail) {
        pickAddress(
          {
            position: newPos,
            full_address: address || "",
          },
          0
        );
      }
    });
  };
  const handleDragEnd = (event: google.maps.MapMouseEvent, index: number) => {
    if (event.latLng) {
      const newPos = { lat: event.latLng.lat(), lng: event.latLng.lng() };
      geocodeLatLng(newPos, (_, address) => {
        if (pickAddress && event.latLng) {
          pickAddress(
            {
              position: { lat: event.latLng.lat(), lng: event.latLng.lng() },
              full_address: address || "",
            },
            index
          );
        }
      });
    }
  };
  return (
    <Map
      mapId={MAP_ID_KEY}
      {...{ ...options, style }}
      defaultCenter={center}
      defaultZoom={17}
      onClick={onMapClick}
      disableDoubleClickZoom={isActions}
      gestureHandling={isActions ? "none" : "auto"}
    >
      {markers &&
        markers.map((el, index) => (
          <PickedMarkers
            isActions={isActions}
            full_address={el.fullAddress}
            position={el.position}
            func={handleDragEnd}
            index={index}
            providers={el.providers}
            key={el.position.lat}
          />
        ))}
      {nearByMarkers?.near50 &&
        nearByMarkers.near50.length > 0 &&
        nearByMarkers.near50.map((el) => (
          <NearByMarkers
            markerData={el}
            source="50"
            position={el.position}
            key={el.position.lat}
          />
        ))}
      {nearByMarkers?.near300 &&
        nearByMarkers.near300.length > 0 &&
        nearByMarkers.near300.map((el) => (
          <NearByMarkers
            markerData={el}
            source="300"
            position={el.position}
            key={el.position.lat}
          />
        ))}
    </Map>
  );
}
